export const customerAccess = {
  title: 'Customer Access',
  subtitle: '{{count}} access',
  addAccess: 'Add Access',
  addFirstAccess: 'Add First Access',
  editAccess: 'Edit Access',
  noAccess: 'No Access',
  noAccessDescription: 'No customer portal access exists for this organization yet. Add one to get started.',
  neverLoggedIn: 'Never logged in',
  organization: 'Organization',

  columns: {
    user: 'User',
    role: 'Role',
    status: 'Status',
    lastLogin: 'Last Login',
    actions: 'Actions',
  },

  role: {
    primary: 'Primary Contact',
    secondary: 'Secondary User',
  },

  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
  },

  actions: {
    edit: 'Edit',
    delete: 'Delete',
    resendInvitation: 'Resend Invitation',
  },

  form: {
    user: 'User',
    selectUser: 'Select a user',
    userCannotChange: 'User cannot be changed after creation',
    role: 'Role',
    status: 'Status',
    permissions: 'Permissions',
    notes: 'Notes',
    notesPlaceholder: 'Optional notes about this access...',
  },

  permissions: {
    canViewDocuments: 'View Documents',
    canUploadDocuments: 'Upload Documents',
    canViewInvoices: 'View Invoices',
    canCreateTickets: 'Create Tickets',
    canViewTickets: 'View Tickets',
    canViewOrders: 'View Orders',
    canPlaceOrders: 'Place Orders',
  },

  messages: {
    created: 'Access successfully created',
    updated: 'Access successfully updated',
    deleted: 'Access successfully deleted',
    error: 'Error saving access',
    deleteError: 'Error deleting access',
    invitationSent: 'Invitation successfully sent',
    invitationError: 'Error sending invitation',
    activated: 'Access activated',
    deactivated: 'Access deactivated',
    toggleError: 'Error updating status',
  },

  deleteModal: {
    title: 'Delete Access',
    message: 'Are you sure you want to delete access for {{name}}?',
    warning: 'This action cannot be undone. The user will lose access to the customer portal.',
  },
};
